import React, { useState, useRef, useEffect } from "react";
import { Map, Marker, InfoWindow } from "@vis.gl/react-google-maps";
import { Clock, MapIcon, MapPin, Navigation, } from "lucide-react";
import { HTTP } from "../api/http-common";

function LocationCardNew({ location, showTime, locationWrapper }) {
  const [selectedLocation, setSelectedLocation] = useState({
    lat: 33.448376,
    lng: -112.074036,
  });
  const handleGetDirections = () => {
    // Generate Google Maps directions URL
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`;
    window.open(mapsUrl, '_blank'); // Open the URL in a new tab
  };
  const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
  const getDynamicClass = (isOpen, openTime, closeTime, day) => {
    // if (!isOpen) {
    //   return "closed";
    // }
    const today = new Date().toLocaleDateString("en-US", {
      weekday: "short",
    }).toLowerCase();
    const isToday = day === today;

    const convertTo24Hour = (time) => {
      const [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);

      if (modifier === "PM" && hours < 12) {
        hours += 12;
      } else if (modifier === "AM" && hours === 12) {
        hours = 0;
      }

      return hours * 60 + minutes;
    };

    const getTimeInMinutes = (time) => {
      if (!time) return null;
      return convertTo24Hour(time);
    };

    const isOpenNow = () => {
      const now = new Date();
      const currentMinutes = now.getHours() * 60 + now.getMinutes();
      const openMinutes = getTimeInMinutes(openTime);
      const closeMinutes = getTimeInMinutes(closeTime);

      if (openMinutes === null || closeMinutes === null) return false;

      // Handle overnight cases (e.g., openTime: 23:00, closeTime: 02:00)
      if (openMinutes > closeMinutes) {
        return currentMinutes >= openMinutes || currentMinutes < closeMinutes;
      }

      return currentMinutes >= openMinutes && currentMinutes < closeMinutes;
    };
    if (isToday) {
      return isOpenNow() ? "open" : "closed";
    } else {
      return "";
    }

    // return isToday && isOpenNow() ? "open" : "closed";
  };
  useEffect(() => {
    setSelectedLocation(location);

  }, [location]);
  return (
    <>
      <div className={`"  ${showTime == 0 ? '' : `${locationWrapper} px-[20px] py-[10px] rounded-lg mb-2  flex flex-col xl:flex-row bg-white `} `}>
        {/* <div className="flex bg-white rounded-lg mb-2 border px-[20px] py-[10px]"> */}
        <div className={`${showTime == 1 ? 'w-full xl:w-1/3 ' : 'w-full'} p-[5px] xl:p-[10px]`}>

          <div className=" ">
            <div className="custom-map-target flex flex-col justify-center">
              <Map
                style={{ borderRadius: "20px", height: "200px", width: "100%" }}
                defaultZoom={14}
                className="map-container"
                center={{ lat: selectedLocation.lat, lng: selectedLocation.lng }}
                gestureHandling="greedy"
                disableDefaultUI
              >
                <Marker className="test-123" key={location.id} position={{ lat: location.lat, lng: location.lng }}>
                  <InfoWindow
                    position={{ lat: location.lat, lng: location.lng }}

                  >
                    <div>
                      <h2 className="font-bold text-lg">{location.address}</h2>
                      <p>
                        {location.state} {location.city_name} {location.postal_code}
                      </p>
                    </div>
                  </InfoWindow>
                </Marker>
              </Map>

              <button
                onClick={handleGetDirections}

                className="mx-[20px] my-[10px] text-white font-semibold px-4 py-1.5 rounded-lg  transition duration-300 theme-button"
              >
                <span className="flex items-center justify-center">
                  <span>

                    Get Direcion
                  </span>
                  <MapPin className="ml-1 w-4 " />
                </span>
              </button>
            </div>
          </div>
        </div>
        {showTime == true ? <div className="w-full xl:w-2/3 map-card-section">


          <div className="address-card">
            <div
              key={location.id}
              className={` mb-2`}
            >
              {/* <div className="flex items-start justify-between cursor-pointer p-2  border-b border-gray-300">
                <div>
                  <p className="text-gray-800 text-base font-semibold mb-0.5">{location.address}</p>
                  <p className="text-gray-600 text-xs">
                    {location.city_name}, {location.state} - {location.postal_code}
                  </p>
                </div>
                
              </div> */}
              <div className="px-2">
                <div className="grid grid-cols-2 lg:grid-cols-3  gap-2">
                  {days.map((day) => {
                    const isOpen = location[`is_${day}_open`];
                    const openTime = location[`${day}_open_time`];
                    const closeTime = location[`${day}_close_time`];
                    const dynamicClass = getDynamicClass(isOpen, openTime, closeTime, day);

                    return (
                      <div key={day} className={` bg-gray-100 px-1 py-1 rounded-md`}>
                        <p className="text-gray-800 text-center text-sm font-semibold card-day-text">{day.toUpperCase()}</p>
                        {isOpen ? (
                          openTime && closeTime ? (
                            <div className="py-1">

                              {/* <table className="w-full text-center text-xs ">
                                    <tbody>
                                        <tr>
                                          <td className="text-gray-500 font-semibold">From:  <p className="text-gray-600 py-0.5 open-time-text">{openTime}</p></td>
                                          <td className="text-gray-500 font-semibold">To:  <p className="text-gray-600">{closeTime}</p></td>
                                        </tr>
                                    </tbody>
                                    </table> */}
                              <div className=" items-center text-sm">
                                <div className="">
                                  <p className="flexbox justify-between time-detail-text border-b pb-[5px]">
                                    <span className="text-gray-500 font-semibold mr-1"> From:</span>
                                    <span>{openTime} </span>
                                  </p>
                                </div>
                                <div className="">
                                  <p className="flexbox justify-between time-detail-text">
                                    <span className="text-gray-500 font-semibold mx-1"> To:</span>
                                    <span>{closeTime} </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <span className="text-gray-600">Open</span>
                          )
                        ) : (
                          <div className="flexbox justify-center h-[40px] xl:h-[70px]">
                            <p className="text-red-500 text-center text-xs py-1">Closed</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

        </div> : null}

      </div>
    </>
  )
}

export default LocationCardNew